import {Box, Typography} from '@mui/material';
import {t} from 'i18next';
import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import ReviewEvidenceSource from './ReviewEvidenceSource';
import SourceDetailsTab from './SourceDetailsTab';
import {RootState} from '../../../../redux/store';
import AurBreadcrumb from '../../../common/aur-breadcrumb/AurBreadCrumb';
import AurStepper from '../../../common/aur-stepper-tab/AurStepperTab';
import {isEmpty} from 'lodash';
import {
  GA_CLICK_TYPES,
  GA_EVENT_NAMES,
  GA_REGIONS,
  GA_SUBPAGE_TYPE,
} from '../../../../constants/analyticsConstants';
import {useAnalytics} from '../../../../hooks/useAnalytics';

const UploadNewEvidence: React.FC = () => {
  const {trackGAEvent} = useAnalytics();

  const steps = [
    {label: t('uploadEvidence.sourceDetails')},
    {label: t('uploadEvidence.review')},
  ];
  const [activeStep, setActiveStep] = useState(0);

  const acknowledgementDateTime = useSelector(
    (state: RootState) =>
      state.uploadEvidenceSource?.sourceDetails?.acknowledgementDateTime
  );

  useEffect(() => {
    if (!isEmpty(acknowledgementDateTime)) {
      setActiveStep(1);
    }
  }, [acknowledgementDateTime]);

  const breadCrumbItems = [
    {
      label: t('welcomeScreenSingleClient.projectOverview'),
      path: '/welcome-single-client',
    },
  ];

  const projectName = useSelector(
    (state: RootState) =>
      state.uploadEvidenceSource.selectedProject?.projectName ?? ''
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeStep]);

  return (
    <div className="upload-evidence-header aur-custom-index">
      <Box className="evidence-source-container">
        <AurBreadcrumb items={breadCrumbItems} />
        <Typography
          tabIndex={0}
          className="typo-text headline1_size source-heading"
          role="heading"
          aria-level={1}
        >
          {t('uploadEvidence.newEvidence')}
        </Typography>
        <AurStepper
          activeStep={activeStep}
          steps={steps}
          setActiveStep={(value: number) => {
            trackGAEvent({
              eventName: GA_EVENT_NAMES.CLICK,
              click: {
                name:
                  value === 0
                    ? t('gaTracking.uploadEvidence.sourceDetails')
                    : t('gaTracking.uploadEvidence.review'),
                type: GA_CLICK_TYPES.TAB,
                region: GA_REGIONS.BODY,
                action: t(
                  'gaTracking.uploadEvidence.uploadEvidenceTabSwitched',
                  {
                    type:
                      value === 0
                        ? t('gaTracking.uploadEvidence.sourceDetails')
                        : t('gaTracking.uploadEvidence.review'),
                  }
                ),
              },
              subPage: {
                subpage_name:
                  value !== 0
                    ? t('gaTracking.uploadEvidence.sourceDetails')
                    : t('gaTracking.uploadEvidence.review'),
                subpage_type: GA_SUBPAGE_TYPE.TAB,
              },
            });
            trackGAEvent({
              eventName: GA_EVENT_NAMES.SUB_PAGE_VIEW,

              subPage: {
                subpage_name:
                  value === 0
                    ? t('gaTracking.uploadEvidence.sourceDetails')
                    : t('gaTracking.uploadEvidence.review'),
                subpage_type: GA_SUBPAGE_TYPE.TAB,
              },
            });
            setActiveStep(value);
          }}
        />
      </Box>

      <div
        className={`${activeStep == 2 ? 'content analyzer-content' : 'content content-backgroundcolor'}`}
      >
        {activeStep == 0 ? (
          <Box className="source-details-container">
            <Typography
              tabIndex={0}
              className="typo-text headline3_size heading-1"
              role="heading"
              aria-level={2}
            >
              {t('eca.newExport.startBasics')}
            </Typography>

            <Typography
              tabIndex={0}
              className="typo-text subhead4_size project"
              role="heading"
              aria-level={3}
            >
              {t('uploadEvidence.project')}
            </Typography>

            <Typography tabIndex={0} className="typo-text subhead1_size">
              {projectName}
            </Typography>

            <SourceDetailsTab setActiveStep={setActiveStep} />
          </Box>
        ) : null}
        {activeStep == 1 ? (
          <Box className="review-details-container">
            <ReviewEvidenceSource setActiveStep={setActiveStep} />
          </Box>
        ) : null}
      </div>
    </div>
  );
};

export default UploadNewEvidence;
